export default "__VITE_ASSET__CkKgwMSt__"